import { render, staticRenderFns } from "./lrUserSelect.vue?vue&type=template&id=54194056&"
import script from "./lrUserSelect.vue?vue&type=script&lang=js&"
export * from "./lrUserSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports